(function () {
  'use strict';

  angular
    .module('chartModule', [
      'highcharts-ng'
    ]);
}());
